<template>
  <div class="c-group-box">
    <div class="c-header">
      <Checkbox class="c-check-item" v-model="all" :indeterminate="indeter" :disabled="disabled" v-if="extend">全选</Checkbox>
      <span>{{ title }}</span>
      <div class="c-cataract" v-if="extend" @click.stop="selectAll"></div>
    </div>
    <div class="c-search" :class="{ 'm-disabled': disabled }" v-if="!result">
      <Input v-model="keyword" placeholder="请输入关键字搜索" clearable search :disabled="disabled" />
    </div>
    <div class="c-content">
      <Spin size="large" fix v-if="loading" />
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'groupBox',
  props: {
    value: {
      type: [String, Number],
      default() {
        return ''
      }
    },
    title: {
      type: String
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    level: {
      type: Number
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    result: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    keyword: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    all() {
      const len = this.data.filter((ret) => ret.check).length
      return this.data.length === len
    },
    extend() {
      return Boolean(this.data.length)
    },
    indeter() {
      return this.data.some((ret) => ret.check) && !this.data.every((ret) => ret.check)
    }
  },
  methods: {
    selectAll() {
      this.$emit('on-select', {
        check: !this.all,
        level: this.level
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-group-box {
  background-color: #fff;
  position: relative;
  min-height: 448px;

  .c-header {
    padding: 0 12px;
    height: 34px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #e8eaec;
    background-color: #f8f8f8;
    position: relative;

    span {
      line-height: 34px;
      vertical-align: middle;
    }

    .c-check-item {
      float: right;
      margin-right: 0;
      margin-top: 9px;

      ::v-deep .ivu-checkbox {
        margin-right: 0;
      }
    }

    .c-cataract {
      position: absolute;
      width: 42px;
      height: 34px;
      top: 0;
      right: 12px;
      z-index: 8;
      cursor: pointer;
    }
  }

  .c-search {
    width: 100%;
    padding: 8px 12px;
    background-color: #fff;
    font-size: 12px;

    ::v-deep.el-input {
      font-size: 12px;
    }

    ::v-deep.el-input__icon,
    ::v-deep.el-input__inner {
      height: 30px;
      line-height: 30px;
    }

    ::v-deep.el-input__inner {
      padding-left: 7px;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }

    ::v-deep.el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      padding: 8px 12px;

      i {
        font-size: 12px;
        display: inline;
      }
    }
  }

  .m-disabled {
    ::v-deep.el-button--primary {
      background-color: #a0cfff;
      border-color: #a0cfff;
    }
  }

  .c-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    position: relative;
    height: 368px;
    width: 100%;
    padding-bottom: 8px;
  }
}

/* 半选状态 */
::v-deep.ivu-checkbox-indeterminate {
  .ivu-checkbox-inner {
    background-color: #6fb3fb;
    border-color: #6fb3fb;
  }
}
</style>
